import { useQuery } from '@tanstack/react-query';
import {
  getCompanyTimeline,
  getIdentifiedPeople,
  getJourney,
  getJourneys,
  getLinkedInLeads,
  getVisitingCompanies,
  type ListPeriod,
} from '../api/web-analytics';

export function useJourneys(period: ListPeriod) {
  return useQuery({
    queryKey: ['web-analytics', 'journeys', period.startDate, period.endDate],
    queryFn: () => getJourneys(period),
  });
}

export function useJourney(email: string | null) {
  return useQuery({
    queryKey: ['web-analytics', 'journey', email],
    queryFn: () => getJourney(email!),
    enabled: email !== null,
  });
}

export function useVisitingCompanies(period: ListPeriod) {
  return useQuery({
    queryKey: ['web-analytics', 'companies', period.startDate, period.endDate],
    queryFn: () => getVisitingCompanies(period),
  });
}

export function useIdentifiedPeople(period: ListPeriod) {
  return useQuery({
    queryKey: ['web-analytics', 'identified-people', period.startDate, period.endDate],
    queryFn: () => getIdentifiedPeople(period),
  });
}

export function useCompanyTimeline(domain: string | null) {
  return useQuery({
    queryKey: ['web-analytics', 'company-timeline', domain],
    queryFn: () => getCompanyTimeline(domain!),
    enabled: domain !== null,
  });
}

export function useLinkedInLeads(period: ListPeriod) {
  return useQuery({
    queryKey: ['web-analytics', 'linkedin-leads', period.startDate, period.endDate],
    queryFn: () => getLinkedInLeads(period),
  });
}
